import React, { useEffect } from 'react'
import * as echarts from 'echarts'

export default function PassengerTypeChart({ passengerTypeCounts = {adult_count: 0, child_count: 0, infant_count: 0, senior_count: 0, total_passengers: 0} }) {
    useEffect(() => {
        const chartDom = document.getElementById('passengerTypeChart')
        const myChart = echarts.init(chartDom)

        // Define colors for passenger type
        const colors = {
            ADULT: '#5d8e9a',
            CHILD: '#0c505b',
            INFANT: '#caa72b',
            SENIOR: '#ebe2d6',
        }

        const data = [
            {name: "Adults", value: passengerTypeCounts.adult_count}, 
            {name: "Children", value: passengerTypeCounts.child_count}, 
            {name: "Infants", value: passengerTypeCounts.infant_count}, 
            {name: "Seniors", value: passengerTypeCounts.senior_count}
        ]
        const option = {
            tooltip: {
                trigger: 'item',
                formatter: function (params) {
                    return `${params.name}<br/>${params.value}`
                },
            },
            graphic: {
                elements: [
                    {
                        type: 'text',
                        left: '22%',
                        top: '45%',
                        style: {
                            text: 'Passengers',
                            textAlign: 'center',
                            fill: '#64749A',
                            fontSize: window.innerWidth < 640 ? 12 : 16,
                            fontWeight: 'bold',
                        },
                    },
                ],
            },
            legend: {
                orient: 'vertical',
                right: '5%',
                top: 'center',
                itemWidth: window.innerWidth < 640 ? 8 : 10,
                itemHeight: window.innerWidth < 640 ? 20 : 30,
                itemGap: window.innerWidth < 640 ? 12 : 20,
                textStyle: {
                    fontSize: window.innerWidth < 640 ? 10 : 12,
                },
                icon: 'circle',
                formatter: name => {
                    const item = data.find(d => d.name === name)
                    return `${item.value} ${name}`
                },
            },
            series: [
                {
                    name: 'Passengers',
                    type: 'pie',
                    radius: ['65%', '95%'],
                    center: ['30%', '50%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                    },
                    labelLine: {
                        show: false,
                    },
                    data: data,
                    emphasis: {
                        scale: false,
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            ],
        }

        myChart.setOption(option)

        const handleResize = () => {
            myChart.resize()
        }
        window.addEventListener('resize', handleResize)

        // Initial resize to ensure proper rendering
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize)
            myChart.dispose()
        }
    }, [passengerTypeCounts])

    return (
        <div className="relative w-full h-full">
            <div id="passengerTypeChart" className="w-full h-[180px] sm:h-[230px]"></div>
        </div>
    )
}
